import { useGetAllProvincesQuery } from '@exam-center/graphql';

import { BaseSearchSelection } from '../base-search-selection';

interface ProvinceSearchSelectionProps {
  value: { label: string; value: string }[];
}

export default function ProvinceSearchSelection(props: Readonly<ProvinceSearchSelectionProps>) {
  const { value } = props;
  const { data } = useGetAllProvincesQuery();

  const provinces = data?.ecGetAllProvinces?.provinces ?? [];
  const provinceOptions = provinces
    .map((province) => ({
      label: province.nameTh,
      value: province.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <BaseSearchSelection name='province' options={provinceOptions} label='จังหวัด' value={value} />
  );
}
